import React from "react"
import { SearchIcon } from "../../../util/Icons"

export const SearchBar = ({ placeholder, isLoading, onInput }) => {
    return (
        <form
            style={{
                padding: "12px 16px",
                height: "46px",
            }}
            className="d-flex bg-white position-sticky top-0 zindex-1 border-bottom" onSubmit={(e) => e.preventDefault()}
        >
            <div>
                {
                    isLoading
                        ? <div className="spinner-border spinner-border-sm text-primary mr-3" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                        : <div className="mr-3 h-100 d-flex align-items-center">
                            <SearchIcon size={"14px"} />
                        </div>
                }
            </div>
            <input
                style={{
                    outline: 0,
                }}
                type="text"
                className="col p-0 border-0"
                placeholder={placeholder}
                autoComplete="off"
                onInput={onInput}
            />
        </form>
    )
}